<template>
    <div>
      <header class="lmy-header lmy-header-w">
        <i class="iconfont icon-back" @click="isLeave=true"></i>
        去支付
      </header>
      <div class="lmy-purchase">
        <div class="order-title">订单信息</div>
        <div class="rush-text" style="font-weight: bold;font-size: 0.3rem;">
          {{Details.Name}}
        </div>
        <div class="select-count">
          <div class="select-count-item-a">
            <span>选择份数</span>
            <div class="compute">
              <span class="count">{{Details.Count}}份</span>
            </div>
          </div>
        </div>
        <div class="lmy-reservation-order" style="padding:0;padding-top:.2rem">
            <div v-for="Group,index in Groups">
                <div class="info-title" style="margin-top:0.3rem;color:#c8a973;padding: 0 .35rem;">{{Group.GroupName}} {{index+1}}</div>
                <div v-for="I in Group.Items">
                    <div class="select-count">
                        <p><span class="too">{{I.ItemName}}</span>{{I.Value}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="select-count">
          <p><span class="too">应付总额度</span><span class="price">¥<span>{{Details.Price}}</span></span></p>
        </div>
        <div class="order-title">支付方式</div>
	        <div class="pay-type">
	            <div class="wx-pay">
	                <div class="logo">
	                    <img src="./../../assets/img/wx.png" alt="">
	                </div>
	                微信支付
	            </div>
	            <i class="iconfont icon-check"></i>
	        </div>
        <div class="room-people-toast">由于价格变动频繁,请在10分钟内完成支付</div>
        <div class="lmy-select-btn" @click="book()">去支付</div>

        <div class="cmpnt-modal-box" v-if="isLeave">
          <div class="lmy-mask-s"></div>
          <div class="lmy-modal">
            <div class="lmy-modal-head">提示</div>
            <div class="lmy-modal-body">
              <p>支付尚未完成 ,确定要离开？</p>
            </div>
            <div class="lmy-modal-foot">
              <div class="sort-btn" @click="isLeave=false">继续支付</div>
              <div class="sort-btn" onclick="window.history.go(-1)">离开</div>
            </div>
          </div>
        </div>
        <div class="book-comfirming" v-if="isSubmit">
          <div class='f-modal' >
            <div class='f-modal-head'>提示</div>
            <div class='f-modal-body'>
              <p>正在提交订单，请稍候</p>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "free-bookComfain",
  data: function() {
    return {
      Details: "",
      Groups:'',
      isLeave: false,
      isSubmit: false,
      OrderNO:'',
    };
  },

  mounted() {
    this.Details = JSON.parse(this.dao.get("packageBookRequest"));
    this.Groups = this.Details.Requirement.Groups;
  },
  methods: {
    book() {
      var that = this;
      var param = {
        Count: that.Details.Count,
        Token: that.Details.Token,
        Requirement: that.Details.Requirement,
      };
      that.isSubmit = true;
      that
        .postRequest({
          url: that.Api.getOnlineCreate,
          params: JSON.stringify(param)
        })
        .then(res => {
          
          if (res && res.IsSuccess) {
            that.OrderNO = res.Result.MainOrderID;
            that.dao.set('thisBookingOrderNO',that.OrderNO);
            that.isSubmit = false;
            that.$router.push({ path: '/wxPay',query:{OrderNO:that.OrderNO}});
          } else if (!res.IsSuccess) {
            that.isSubmit = false;
            this.error({ title: "提示", content: res.Msg });
          }
        });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/free/bookComfain.vue